import { create, StateCreator } from "zustand";
import { devtools } from "zustand/middleware";
import { CompleteDailyActivity, DailyCheckIn, DailyReport, DailyCheckOut } from "../../../dailyCheck/models/DailyCheck";

type DailyCheckState = {
  todayActivity: CompleteDailyActivity | null;
  isLoading: boolean;
  setTodayActivity: (activity: CompleteDailyActivity | null) => void;
  setIsLoading: (loading: boolean) => void;
  updateCheckIn: (checkIn: DailyCheckIn) => void;
  updateReport: (report: DailyReport) => void;
  updateCheckOut: (checkOut: DailyCheckOut) => void;
};

const storeApi: StateCreator<DailyCheckState> = (set, get) => ({
  todayActivity: null,
  isLoading: false,
  setTodayActivity: (activity) => {
    set({ todayActivity: activity });
  },
  setIsLoading: (loading) => {
    set({ isLoading: loading });
  },
  updateCheckIn: (checkIn) => {
    const current = get().todayActivity;
    set({
      todayActivity: {
        ...current,
        checkIn,
        status: 'checked-in',
        date: checkIn.date,
        userId: checkIn.userId,
      } as CompleteDailyActivity
    });
  },
  updateReport: (report) => {
    const current = get().todayActivity;
    set({
      todayActivity: {
        ...current,
        report,
        status: 'report-completed',
        date: report.date,
        userId: report.userId,
      } as CompleteDailyActivity
    });
  },
  updateCheckOut: (checkOut) => {
    const current = get().todayActivity;
    set({
      todayActivity: {
        ...current,
        checkOut,
        status: 'completed',
        date: checkOut.date,
        userId: checkOut.userId,
      } as CompleteDailyActivity
    });
  },
});

export const useDailyCheckStore = create<DailyCheckState>()(
  devtools(storeApi, { name: "daily-check-store" })
);